import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import {
  PPC,
  VIDEO,
  TEACHER_AUTHORED,
  PE,
  SPP,
  PDF,
  LEARNING_CHECKPOINTS,
  PERFORMANCE_TASKS,
} from 'chameleon-src/components/assignments/constants';

const iconMapping = {
  [PPC]: 'progress-check',
  [VIDEO]: 'daily-video',
  [TEACHER_AUTHORED]: 'my-quiz',
  [PE]: 'practice-exam',
  [PDF]: 'more_resources',
  [SPP]: 'spp',
  [LEARNING_CHECKPOINTS]: 'learning_checkpoints',
  [PERFORMANCE_TASKS]: 'performance_tasks',
};

const barColorMapping = {
  [PPC]: 'blue-500',
  [VIDEO]: 'purple-600',
  [TEACHER_AUTHORED]: 'orange-600',
  [PE]: 'green-500',
  [PDF]: 'blue-500',
  [SPP]: 'teal',
};

const AssignmentTypeLine = ({ type, horizontalLine = false }) => {
  const barOrientation = horizontalLine ? `w-full h-2` : `h-full w-2`;
  return (
    barColorMapping[type] && (
      <div
        className={`absolute top-0 left-0 inline-block ${barOrientation}  bg-${barColorMapping[type]}`}
      />
    )
  );
};

const AssignmentTypeIcon = ({
  type,
  showLine = false,
  horizontalLine = false,
  height,
  width,
}) => {
  if (showLine) {
    return <AssignmentTypeLine type={type} horizontalLine={horizontalLine} />;
  }

  return iconMapping[type] ? (
    <Icon
      id={iconMapping[type]}
      role="presentation"
      accessibility={{ ariaHidden: true }}
      {...(height ? { height } : {})}
      {...(width ? { width } : {})}
    />
  ) : (
    ''
  );
};

export default AssignmentTypeIcon;
